import styled from "styled-components"
import Video from "./component"

export default styled(Video)`
    .video {
        border-radius: 6px;
    }
`
